// One email of a sequence as written: step 1 with its subject, steps 2 and 3 as replies in thread.

import type { SendStep } from '../api/types';

export function StepView({ step, index }: { step: SendStep; index: number }) {
  return (
    <div className="sendstep">
      <div className="sendstephead">Email {index + 1}{step.subject ? <> · <b>{step.subject}</b></> : <span className="sendquiet"> · reply in thread</span>}</div>
      <pre className="sendbody">{step.body}</pre>
    </div>
  );
}
